import React from "react";
import ImageGallery from "react-image-gallery";
import "./gallery.styles.scss";

class MyGallery extends React.Component {
  render() {
    let images = [];
    this.props.photos.forEach((photo) => {
      images.push({
        original: `${photo}`,
        thumbnail: `${photo}`,
        originalClass: 'photo'
      });
    });

    //Oonly díplay last 4 photos
    let filterImages =[];
    if(images.length > 4){
      for (let i = images.length -1; i > images.length - 5; i--)
      filterImages.push(images[i]);
    } else {
      filterImages = images;
    }
    return <ImageGallery items={filterImages} />;
  }
}

export default MyGallery;
